import { defineStore } from "pinia";
import { CaptionModel, CaptionState } from "../utils/captionModel";
import { AvailableCaption } from "../utils/availableCaptionModel";
import { Language, languages } from "../utils/languageList";
import { SelectedVideo } from "../utils/selectedVideo";
import { CustomPlayer } from "../utils/customPlayer";
interface VideoState {
  processingStarted: boolean;
  receivedCaption: boolean;
  hasCaption: boolean;
  hasVideo: boolean;
  isNotValidLink: boolean;
  notReadyYet: boolean;
  isTargetListOpen: boolean;
  isFromNotification: boolean;
  isTargetLanguageSelected: boolean;
  balanceNotEnough: boolean;
  computePricing: boolean;
  captions: CaptionModel[];
  availableCaptions: AvailableCaption[];
  activeCaptionLang: string | "";
  userInput: string | "";
  originalVideoSubtitle: string | "";
  translatedVideoSubtitle: string | "";
  translatedText: string | "";
  prebuildVideoSubtitle: string | ``;
  originalText: string | ``;
  searchQuery: string | "";
  myLanguagesList: Language[];
  isTranslationListOpened: boolean;
  translationLanguage: Language;
  originalLanguage: Language;
  isOpen: boolean;
  player: any | null;
  currentTime: number;
  currentCaptions: CaptionModel[];
  currentRequestId: string | "";
  mountPlayer: boolean;
  videoPlayer : CustomPlayer | null;
  textTranslationPrice: number;
  selectedVideo: SelectedVideo;
  userInputVideoLink: string | "";
  isTranslationPreview: boolean;
  processingStatus: string | "";
  progressBar: number;
  ffmpegPercentage: number;
  fileUploadPercentage: number;
  fileUploaded: boolean;
  showDownloadTypes:boolean;
  fontFamily: string | "";
  fontSizePercent: number;
  fontFamilyListShow: boolean;
  audioContent: string | "";
  audioContentTranslated: string | "";
  selectedVoice: string | "";
  selectedVoiceTranslated: string | "";
  videoUrl: string | "";
  defaultOriginalVideoSubtitle: string | ``;
  defaultTranslatedVideoSubtitle: string | ``;
  defaultOriginalText: string | ``;
  defaultTranslatedText: string | ``;
  pickedColor: any | null,
  originalJsonContent: any | null,
  latestTranslationTarget: string | '',
  showTextTab: boolean,
  processingLink: boolean,
  intervalId: any | null;
  pickedColorCaptions: any | null;
  pickedBackgroundColor: any | null;
  useCaptionBackground: boolean;
  fileName: string | '';
  originalSummarizedText: string | ``;
  translatedSummarizedText: string | "";
  showOriginalSummarized: boolean;
  showTranslatedSummarized: boolean;
  origineTokenValue: number;
  translatedTokenValue: number;
  activeAudioDubbing: any,
  summarizesData: any[];
  latestTranslationId: string | "";
  dubbingEnabled: boolean;
  storedCaptions: CaptionState[];
  loadedDubbingCached: boolean;
  audioSource: any;
  audioSourceTranslated: any;
  parsedCaptionsWithSpeakers: CaptionModel[];
  isMultiLanguageMode: boolean;
  selectedTargetLanguages: Language[];
  bulkTextTranslations: Record<string, string>;
  currentDisplayLanguage: Language;
  /** Help modal: scroll target when result panel is visible */
  pendingHelpScrollSectionId: string | null;
}

export const useVideoStore = defineStore("videoStore", {
  state: (): VideoState => ({
    processingStarted: false,
    receivedCaption: false,
    hasCaption: false,
    hasVideo: false,
    isNotValidLink: false,
    captions: [],
    availableCaptions: [],
    activeCaptionLang: "",
    userInput: "",
    originalVideoSubtitle: "",
    translatedVideoSubtitle: "",
    prebuildVideoSubtitle: ``,
    translatedText: "",
    originalText: "",
    notReadyYet: false,
    isFromNotification: false,
    isTargetListOpen: false,
    isTargetLanguageSelected: false,
    searchQuery: "",
    myLanguagesList: languages,
    isTranslationListOpened: false,
    translationLanguage: {
      langName: "Arabic",
      langCode: "ar",
      countryCode: "sa",
    },
    originalLanguage: {
      langName: "",
      langCode: "",
      countryCode: "",
    },
    isOpen: false,
    balanceNotEnough: false,
    computePricing: false,
    player: null,
    currentTime: 0,
    currentCaptions: [],
    currentRequestId: "",
    mountPlayer: false,
    videoPlayer: null,
    textTranslationPrice: 0,
    selectedVideo: {name: ""},
    userInputVideoLink: "",
    isTranslationPreview: false,
    processingStatus: "",
    progressBar: 0,
    ffmpegPercentage: 0,
    fileUploadPercentage: 0,
    fileUploaded: false,
    fontFamily: "Arial",
    showDownloadTypes: false,
    fontSizePercent: 50,
    fontFamilyListShow: false,
    audioContent: "",
    audioContentTranslated: "",
    selectedVoice: "none",
    selectedVoiceTranslated: "none",
    videoUrl: "",
    defaultOriginalVideoSubtitle: ``,
    defaultTranslatedVideoSubtitle: ``,
    defaultOriginalText: "",
    defaultTranslatedText: "",
    pickedColor: "000000",
    pickedColorCaptions: "#FFFFFF",
    pickedBackgroundColor: "#000000",
    originalJsonContent: null,
    latestTranslationTarget: '',
    showTextTab: true,
    processingLink: false,
    intervalId: null,
    useCaptionBackground: true,
    fileName: "",
    originalSummarizedText: "",
    translatedSummarizedText: "",
    showOriginalSummarized: false,
    showTranslatedSummarized: false,
    origineTokenValue: 120,
    translatedTokenValue: 120,
    activeAudioDubbing: {},
    summarizesData: [],
    latestTranslationId: "",
    dubbingEnabled: false,
    storedCaptions: [],
    loadedDubbingCached: false,
    audioSource: null,
    audioSourceTranslated: null,
    parsedCaptionsWithSpeakers: [],
    isMultiLanguageMode: false,
    selectedTargetLanguages: [],
    bulkTextTranslations: {},
    currentDisplayLanguage: {
      langName: "Arabic",
      langCode: "ar",
      countryCode: "sa",
    },
    pendingHelpScrollSectionId: null,
}),


  actions: {
    setRequest(requestId: string): void {},
  },
});